<template>
	<a v-show="isVisible" href="#" class="back-to-top" @click.prevent="scrollToTop">
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-4.98 3.66l-.163 .01l-.086 .016l-.142 .045l-.113 .054l-.07 .043l-.095 .071l-.058 .054l-4 4l-.083 .094a1 1 0 0 0 1.497 1.32l2.293 -2.293v5.586l.007 .117a1 1 0 0 0 1.993 -.117v-5.585l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-4 -4l-.082 -.073l-.089 -.064l-.113 -.062l-.081 -.034l-.113 -.034l-.112 -.02l-.098 -.006z" stroke-width="0" fill="currentColor" />
		</svg>
	</a>
</template>
<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";
const isVisible = ref(false); 

const handleScroll = () => {
	isVisible.value = window.scrollY > 150;
};
const scrollToTop = () => {
	window.scrollTo({ top: 0, behavior: 'smooth' });
};
onMounted(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});
</script>
<style scoped>
.back-to-top {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	bottom: 20px;
	right: 20px;
	z-index: 1000;
	width: 60px;
	height: 60px;
	color: black;
	background-color: transparent;
	border-radius: 50%;
	opacity: 0.35;
	transition: opacity 0.3s ease;
}
.back-to-top:hover {
		opacity: 1;
}

svg {
		width: 36px;
		height: 36px;
	}
</style>